import { View, Modal, StyleSheet, TouchableOpacity } from 'react-native'
import React from 'react'
import { Button, Text } from '@libs/components'
import { useTheme } from '@libs/theme'

const ConfirmationModal = ({
  visible = false,
  onClose = () => {},
  onConfirm = () => {},
  title = '',
  message = '',
  confirmButtonLabel = 'Confirm',
  cancelButtonLabel = 'Cancel',
  titleVariant = 'heading6',
  messageVariant = 'body2',
  children = null, // Allow custom content
  showButtons = true, // Control whether to show buttons
  showCloseIcon = false, // Show X icon in top right
}) => {
  const { colors } = useTheme()

  return (
    <Modal
      visible={visible}
      transparent
      onBackdropPress={onClose}
      onRequestClose={onClose}
      animationType="fade"
    >
      <View style={styles.container}>
        <View style={styles.contentContainer}>
          {/* Close Icon (X) */}
          {showCloseIcon && (
            <TouchableOpacity
              style={styles.closeIcon}
              onPress={onClose}
              accessibilityLabel="Close"
            >
              <Text style={styles.closeIconText}>✕</Text>
            </TouchableOpacity>
          )}

          {/* Title */}
          {title ? (
            <Text
              style={styles.title}
              variant={titleVariant}
              color={colors.textPrimary}
            >
              {title}
            </Text>
          ) : null}

          {/* Custom children content or message */}
          {children || (message ? (
            <Text
              style={styles.message}
              variant={messageVariant}
              color={colors.textSecondary}
            >
              {message}
            </Text>
          ) : null)}

          {/* Action Buttons */}
          {showButtons && (
            <View style={styles.buttonContainer}>
              {/* Cancel Button */}
              <Button
                appearance="outline"
                buttonColor={colors.buttonSecondary}
                label={cancelButtonLabel}
                onPress={onClose}
                buttonStyle={styles.cancelButton}
                labelStyle={{
                  color: colors.buttonSecondary,
                  fontWeight: '500',
                }}
              />

              {/* Confirm Button */}
              <Button
                appearance="filled"
                buttonColor={colors.buttonPrimary}
                label={confirmButtonLabel}
                onPress={onConfirm}
                buttonStyle={styles.confirmButton}
                labelStyle={{
                  color: colors.white,
                  fontWeight: '500',
                }}
              />
            </View>
          )}
        </View>
      </View>
    </Modal>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 20,
  },
  contentContainer: {
    backgroundColor: '#ffffff',
    borderRadius: 12,
    padding: 24,
    maxWidth: 500,
    width: '100%',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    position: 'relative',
  },
  closeIcon: {
    position: 'absolute',
    top: 12,
    right: 12,
    width: 32,
    height: 32,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10,
  },
  closeIconText: {
    fontSize: 24,
    color: '#666',
    fontWeight: '300',
  },
  title: {
    marginBottom: 12,
    fontWeight: '600',
  },
  message: {
    marginBottom: 24,
    lineHeight: 22,
    textAlign: 'center',
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: 12,
  },
  cancelButton: {
    paddingHorizontal: 20,
    paddingVertical: 10,
    minWidth: 100,
  },
  confirmButton: {
    paddingHorizontal: 20,
    paddingVertical: 10,
    minWidth: 100,
  },
})

export default ConfirmationModal
